/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  RecordingMode_Enum,
  recordingMode_EnumFromJSON,
  recordingMode_EnumToJSON,
} from "../../../../gen/user_camera/recording_mode";

export const protobufPackage = "skills";

/** Arguments for switching the recording mode. */
export interface SwitchRecordingModeActionArgs {
  /** The recording mode to switch to. */
  recordingMode: RecordingMode_Enum;
}

export interface SwitchRecordingModeResultData {
}

export interface SwitchRecordingModeActionStateData {
}

function createBaseSwitchRecordingModeActionArgs(): SwitchRecordingModeActionArgs {
  return { recordingMode: 0 };
}

export const SwitchRecordingModeActionArgs = {
  encode(message: SwitchRecordingModeActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.recordingMode !== 0) {
      writer.uint32(8).int32(message.recordingMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SwitchRecordingModeActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchRecordingModeActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.recordingMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchRecordingModeActionArgs {
    return { recordingMode: isSet(object.recordingMode) ? recordingMode_EnumFromJSON(object.recordingMode) : 0 };
  },

  toJSON(message: SwitchRecordingModeActionArgs): unknown {
    const obj: any = {};
    if (message.recordingMode !== 0) {
      obj.recordingMode = recordingMode_EnumToJSON(message.recordingMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchRecordingModeActionArgs>, I>>(base?: I): SwitchRecordingModeActionArgs {
    return SwitchRecordingModeActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchRecordingModeActionArgs>, I>>(
    object: I,
  ): SwitchRecordingModeActionArgs {
    const message = createBaseSwitchRecordingModeActionArgs();
    message.recordingMode = object.recordingMode ?? 0;
    return message;
  },
};

function createBaseSwitchRecordingModeResultData(): SwitchRecordingModeResultData {
  return {};
}

export const SwitchRecordingModeResultData = {
  encode(_: SwitchRecordingModeResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SwitchRecordingModeResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchRecordingModeResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SwitchRecordingModeResultData {
    return {};
  },

  toJSON(_: SwitchRecordingModeResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchRecordingModeResultData>, I>>(base?: I): SwitchRecordingModeResultData {
    return SwitchRecordingModeResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchRecordingModeResultData>, I>>(_: I): SwitchRecordingModeResultData {
    const message = createBaseSwitchRecordingModeResultData();
    return message;
  },
};

function createBaseSwitchRecordingModeActionStateData(): SwitchRecordingModeActionStateData {
  return {};
}

export const SwitchRecordingModeActionStateData = {
  encode(_: SwitchRecordingModeActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SwitchRecordingModeActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchRecordingModeActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SwitchRecordingModeActionStateData {
    return {};
  },

  toJSON(_: SwitchRecordingModeActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchRecordingModeActionStateData>, I>>(
    base?: I,
  ): SwitchRecordingModeActionStateData {
    return SwitchRecordingModeActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchRecordingModeActionStateData>, I>>(
    _: I,
  ): SwitchRecordingModeActionStateData {
    const message = createBaseSwitchRecordingModeActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
